module.exports = __webpack_public_path__ + "static/media/upload-icon.beaad7f7.svg";